<script>
  import AuthenticationRequired from "../../../../../components/functional/AuthenticationRequired.svelte";
  import AutoMpsProjectPageBase from "../../../../../auto-mps/AutoMpsProjectPageBase.svelte";
  import AutoMpsProjectSettingsPage from "../../../../../auto-mps/settings/AutoMpsProjectSettingsPage.svelte";
  import WithAutoMpsControlTab from "../../../../../auto-mps/WithAutoMpsControlTab.svelte";
</script>

<AuthenticationRequired>
  <AutoMpsProjectPageBase let:projectId>
    <WithAutoMpsControlTab projectId={projectId}>
      <AutoMpsProjectSettingsPage projectId={projectId}/>
    </WithAutoMpsControlTab>
  </AutoMpsProjectPageBase>
</AuthenticationRequired>
